import { FC } from "react"
import cx from "classnames"
import { FiFileText } from "react-icons/fi"

type Props = {
  className?: string
} & React.HTMLAttributes<HTMLOrSVGElement>

const FileIcon: FC<Props> = ({ className, ...rest }: Props) => {
  return (
    <FiFileText
      className={cx("w-5 h-5 transition-opacity", className)}
      {...rest}
    />
  )
}

export default FileIcon
